import { ReservationType } from "@/types/enums";

export const reservationTypesLabels = {
  [ReservationType.PAST]: "bookings.past",
  [ReservationType.UPCOMING]: "bookings.upcoming",
  [ReservationType.REFUNDED]: "bookings.cancelled",
};
